import { PAYMENT_SUMMARY_ERRORS } from '@acorn-portal/shared/src/utils/constants/ErrorMessages';
import { SORT_CODE_REGEX } from '@acorn-portal/shared/src/utils/constants/Regex';
import * as Yup from 'yup';

const changeBankSchema = () =>
	Yup.object().shape({
		accept_dd_terms: Yup.boolean().oneOf([true], PAYMENT_SUMMARY_ERRORS.detailsCorrect),
		account_number: Yup.string()
			.min(8, PAYMENT_SUMMARY_ERRORS.accountNumber)
			.required(PAYMENT_SUMMARY_ERRORS.accountNumber),
		sort_code: Yup.string()
			.matches(SORT_CODE_REGEX, PAYMENT_SUMMARY_ERRORS.sortCodeValid)
			.required(PAYMENT_SUMMARY_ERRORS.sortCodeValid),

		is_account_holder: Yup.string()
			.required(PAYMENT_SUMMARY_ERRORS.isAccountHolder)
			.trim()
			.matches(/yes/, PAYMENT_SUMMARY_ERRORS.isAccountHolderNo),

		is_only_signatory_required: Yup.string()
			.required(PAYMENT_SUMMARY_ERRORS.isOnlySignatoryRequired)
			.trim()
			.matches(/yes/, PAYMENT_SUMMARY_ERRORS.isOnlySignatoryRequiredNo),
	});

export default changeBankSchema;
